import { Routes, Route, Navigate } from 'react-router-dom';
import {SignUp} from '../../features/auth/components/SignupForm';
import { LoginForm } from '../../features/auth/components/LoginForm';
import Home from '../../features/landing-page/LandingPage';
import ForgotPassword from '../../features/auth/components/ForgotPassword';
import EmailVerification from '../../features/auth/components/VerifyEmail';
import ResetPassword from '../../features/auth/components/resetPassword';
import ProfileSetupPage from '../../features/user/components/ProfileSetupPage';
import UserSubscription  from '../../features/subscription/components/UserSubscription';
import Canvas from '../../features/canvas/components/CreateCanvas';
import UpdateCanvas from '../../features/canvas/components/UpdateCanvas'
import Payment from '../../features/subscription/components/Payment';
import DashboardLayout from '../../features/shared/components/layouts/DashboardLayout';
import DashboardHome from '../../features/dashboard/pages/DashboardHome';
import SettingsLayout from '../../features/shared/components/layouts/SettingsLayout';
import SettingsPage from '../../features/dashboard/pages/SettingsPage';
import AcceptInvitation from '../../services/AcceptInvitation';
import { PublicRoute, PrivateRoute, SiteAccessRoute } from './RouteGuards';
import AdminDashboardLayout from '../../features/shared/components/layouts/AdminDashboardLayout';
import AdminDashboardPage from '../../features/dashboard/pages/AdminDashboardPage';
import CashAccountSetup from '../../features/dashboard/components/dashboard/modules/accounts/CashAccountSetup';
import IncomeSetup from  '../../features/dashboard/components/dashboard/modules/income/IncomeSetup'
import BudgetSetup from  '../../features/dashboard/components/dashboard/modules/budget/BudgetSetup'
import BudgetManualSetup from '../../features/dashboard/components/dashboard/modules/budget/BudgetManualSetup';
import BudgetUpload from '../../features/dashboard/components/dashboard/modules/budget/BudgetUpload';
import SavingSetup from  '../../features/dashboard/components/dashboard/modules/savings/SavingSetup';
import DebtSetup from  '../../features/dashboard/components/dashboard/modules/debt/DebtSetup';
import MortgageSetup from  '../../features/dashboard/components/dashboard/modules/mortgage/MortgageSetup';
import InvestmentSetup from '../../features/dashboard/components/dashboard/modules/investment/InvestmentSetup'
import InvestmentManualSetup from '../../features/dashboard/components/dashboard/modules/investment/InvestmentManualSetup';
import InvestmentUpload from '../../features/dashboard/components/dashboard/modules/investment/InvestmentUpload';
import AboutPage from '../../features/landing-page/AboutPage';
import PricingPage from '../../features/landing-page/PricingPage';
import BlogPage from '../../features/landing-page/BlogPage';
import BlogPostPage from '../../features/landing-page/BlogPostPage';
import TermsPage from '../../features/landing-page/TermsPage';
import PrivacyPolicyPage from '../../features/landing-page/PrivacyPolicyPage';
import SiteAccessVerification from '../../features/auth/components/SiteAccessVerification';


export const AppRouter = () => (

    <Routes>
  <Route path="/site-access" element={<SiteAccessVerification />} />

  <Route element={<SiteAccessRoute />}>
      {/* Public Routes */}
      <Route path="/" element={<PublicRoute><Home /></PublicRoute>} />
      <Route path="/login" element={<PublicRoute><LoginForm /></PublicRoute>} />
      <Route path="/signup" element={<PublicRoute><SignUp /></PublicRoute>} />
      <Route path="/verify-email" element={<PublicRoute><EmailVerification /></PublicRoute>} />
      <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
      <Route path="/reset-password" element={<PublicRoute><ResetPassword /></PublicRoute>} />
      <Route path="/about-us" element={<PublicRoute><AboutPage/></PublicRoute>} />
      <Route path="/pricing" element={<PublicRoute><PricingPage/></PublicRoute>} />
      <Route path="/blog" element={<PublicRoute><BlogPage/></PublicRoute>} />
      <Route path="/terms" element={<PublicRoute><TermsPage /></PublicRoute>} />
      <Route path="/privacy-policy" element={<PublicRoute><PrivacyPolicyPage /></PublicRoute>} />
      <Route path="/:postSlug" element={<PublicRoute><BlogPostPage /></PublicRoute>} />

      {/* Protected Routes */}
      <Route path="/dashboard" element={<PrivateRoute><DashboardLayout /></PrivateRoute>}>
        <Route index element={<DashboardHome />} />
      </Route>

      <Route path="/settings" element={<PrivateRoute><SettingsLayout /></PrivateRoute>}>
        <Route index element={<SettingsPage />} />
      </Route>

      <Route path="/manage-portal" element={<PrivateRoute><AdminDashboardLayout /></PrivateRoute>}>
        <Route index element={<AdminDashboardPage />} />
      </Route>

    <Route path="/setup-profile" element={<PrivateRoute><ProfileSetupPage /></PrivateRoute>} />
    <Route path="/user-subscription" element={<PrivateRoute><UserSubscription /></PrivateRoute>} />
    <Route path="/payment" element={<PrivateRoute><Payment /></PrivateRoute>} />
    <Route path="/create-canvas" element={<PrivateRoute><Canvas /></PrivateRoute>} />
    <Route path="/update-user-currency" element={<PrivateRoute><UpdateCanvas /></PrivateRoute>} />
    <Route path="/account" element={<PrivateRoute><CashAccountSetup /></PrivateRoute>} />
    <Route path="/income" element={<PrivateRoute><IncomeSetup/></PrivateRoute>} />
    <Route path="/budget" element={<PrivateRoute><BudgetSetup/></PrivateRoute>} />
    <Route path="/budget/manual" element={<PrivateRoute><BudgetManualSetup/></PrivateRoute>} />
    <Route path="/budget/upload" element={<PrivateRoute><BudgetUpload/></PrivateRoute>} />
    <Route path="/saving" element={<PrivateRoute><SavingSetup/></PrivateRoute>} />
    <Route path="/debt" element={<PrivateRoute><DebtSetup/></PrivateRoute>} />
    <Route path="/mortgage" element={<PrivateRoute><MortgageSetup/></PrivateRoute>} />
    <Route path="/investment" element={<PrivateRoute><InvestmentSetup/></PrivateRoute>} />
    <Route path="/investment/manual" element={<PrivateRoute><InvestmentManualSetup/></PrivateRoute>} />
    <Route path="/investment/upload" element={<PrivateRoute><InvestmentUpload/></PrivateRoute>} />
    
    
    {/* Special Routes */}
    <Route path="/accept-invite" element={<AcceptInvitation />} />
    <Route path="/accept-invite/:token" element={<AcceptInvitation />} />
    <Route path="/cashbot" element={<PrivateRoute><BudgetSetup/></PrivateRoute>} />
    <Route path="/next" element={<PrivateRoute><IncomeSetup/></PrivateRoute>} />
    
    {/* Catch all route */}
    <Route path="*" element={<Navigate to="/" replace />} />
    </Route>
  </Routes>
);